import React, { Fragment } from "react";

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
// import { UsePlaceAuth } from "../../../../../../AppContext/AppContext";
import { useSelector } from "react-redux";

function SecondSlider({ handleClick }) {
  const place = useSelector(state => state.place)
  var settings = {
    items: 3,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      991: {
        items: 3
      }
    }
  };
  return (
    <Fragment>
      <div className="col-lg-12 col-12">
        <div className="slider-restaurent">
          <div data-aos="zoom-in-left" className="slider-main">
            <div className="slider-heading">
              <h3>{`${place?.replace(/\b\w/g, x => x?.toUpperCase())} by Food`}</h3>
            </div>
            <div className="clickable" id="slide-restaurent">
              <OwlCarousel {...settings}>
                {[
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/mexican-cuisine.jpg", alt: "Mexican" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/lunchnew.jpg", alt: "Lunch" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/cheapeat.jpg", alt: "Cheap Eats" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/coffytea.jpg", alt: "Coffee & Tea" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/seafoodnew.jpg", alt: "Seafood" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/brkfirstImg.jpg", alt: "Breakfast" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/chinese-cuisine.jpg", alt: "Chinese" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/italian-cuisine.jpg", alt: "Italian" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/pizza-cuisine.jpg", alt: "Pizza" },
                  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/barbecue-beef.jpg", alt: "Barbeque" },
                ].map(({ src, alt }) => (
                  <div data-aos="zoom-in-right" key={alt}>
                    <div className="slider-block">
                      <img loading="lazy" src={src} alt={alt} onClick={(e) => handleClick(alt)} />
                      <div className="slider-content">
                        <h3 onClick={(e) => handleClick(alt)}>{alt}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default SecondSlider;
